export const R = 82;
export const L = 76;
export const D_QUOTE = 34;
export const S_QUOTE = 39;
export const ASTERISK = 42;
